import { makeRestApiRequest,RestApiRequestConfig } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IGroup } from '~src/userManagement/groups/serverApi/types/IGroup';

import { createBaseRestConfig } from '../GroupSetsServerApiHelper';


export interface IAddGroupToGroupSetResult extends IResult {
    groups: IGroup[];
}

export async function addGroupToGroupSet(groupSetId: string, groupId: string): Promise<IAddGroupToGroupSetResult> {
    const config: RestApiRequestConfig<{}, {}> = {
        ...createBaseRestConfig(),
        httpMethod: 'PUT',
        endpoint: `groupsets/` + groupSetId + `/groups/` + groupId,
    };

    let response = makeRestApiRequest<{}, any, {}>(config);
    return response.then((result: any) => {
        return result;
    }, (error) => Promise.reject(error));
}